<template>
  <b-container>
    <div class="body-wrapper">
      <div class="body-title">
        <h5 style="color:#2284ab">{{title}}</h5>
      </div>
      <div class="body-content">

          <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
          <b-alert :show = "showDismissibleAlert" dismissible 
              @dismissed="showDismissibleAlert=false"
              
              :variant="variant">
              {{alertText}}
          </b-alert>
          <b-row class="mt-2">
            <b-col style="text-align:right">
                <b-button @click="survey.prevPage()" v-if="!survey.isFirstPage">Previous</b-button>
                <b-button variant="info" @click="survey.nextPage()" v-if="!survey.isLastPage">Next</b-button>
                <b-button variant="success" @click="survey.completeLastPage()" v-if="survey.isLastPage && survey.mode != 'display'">Complete</b-button>
                <!-- <b-button variant="success" @click="pdfDownload()" v-if="survey.isLastPage && survey.mode != 'display'">Download PDF</b-button> -->
            </b-col>
          </b-row>
          <div style="padding: 10px;
                    border: 2px solid #c4c6be;
                    border-radius: 15px;"  class="mt-2">
                
            <survey :survey="survey"></survey>
            <hr/>
            <b-row class="mt-2">
              <b-col>
                  Page {{survey.currentPageNo + 1}} of {{survey.visiblePageCount}}
              </b-col>
              <b-col style="text-align:right">
                  <b-button @click="survey.prevPage()" v-if="!survey.isFirstPage">Previous</b-button>
                  <b-button variant="info" @click="survey.nextPage()" v-if="!survey.isLastPage">Next</b-button>
                  <b-button variant="success" @click="survey.completeLastPage()" v-if="survey.isLastPage && survey.mode != 'display'">Make Payment</b-button>
                  <!-- <b-button variant="success" @click="pdfDownload()" v-if="survey.isLastPage && survey.mode != 'display'">Download PDF</b-button> -->
              </b-col>
            </b-row>
          </div>

        
      </div>
    </div>
  </b-container>
</template>
<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import * as SurveyVue from "survey-vue";
import Bootstrap from "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import router from "@/router";
import store from "@/store";
import data from "@/data";
import axios from "axios";
import lambda from "@/apis/lambda";

var Survey = SurveyVue.Survey;
Survey.cssType = "bootstrap";
SurveyVue.defaultBootstrapCss.navigationButton = "btn btn-green";

function sendDataToServer(survey, pagenum, iscomplete,ExemptionApplicationID='') {
    // alert(1);
  //Create Object for Payment
  let pmtObj = {};
  let entityName = "";
  var userinfo = store.getters.loggedUser;
  let surveyJSON = {};
  if (userinfo.RegistrationType == 11) {
    pmtObj.pmtPurpose = "Registration of Principal Employer";
    entityName = survey.data.EmployerName;
  } else if (userinfo.RegistrationType == 12) {
    pmtObj.pmtPurpose =
      "Registration of Security Guards Working with Private Agency";
      entityName = survey.data.name;
  } else if (userinfo.RegistrationType == 13) {
    pmtObj.pmtPurpose = "Registration of Employer Agency";
    entityName = survey.data.AgencyName;
  }

  pmtObj.boardId = survey.data.Board;

  store.dispatch("setPmtObject", pmtObj);
  store.dispatch("setRegistrationDetails", survey.data);

  //let userinfo = store.getters.loggedUser;
  var regId = store.getters.getRegId;
  
  var payload = {
    RegistrationID: regId,
    ExemptionApplicationID: ExemptionApplicationID,
    ApplicationDetails: JSON.stringify(survey.data),
    iscomplete: iscomplete,
    LastCompletePage: pagenum,
    RegistrationType: userinfo.RegistrationType,
    BoardID: survey.data.Board,
    RegisteringAgency: "00000000-0000-0000-0000-000000000000",
    EntityName: entityName
  };

  let promise = apis.SaveStgApplicationRegistrationDetails(payload);
  promise
    .then(response => {
      //console.log('Reponse' ,response);
      if (response.status == 200 && response.body != "Error in Registration") {
        store.dispatch("setRegID", response.body);
        if (iscomplete) {
          
          if(userinfo.RegistrationType==13){
            router.push("/registrationfees");
          } else {
            router.push("/onlinepayment");
          }
        }
      } else {
        survey.currentPage = pagenum;
      }
    })
    .catch(err => {
      this.alertText = err.body;
      this.showDismissibleAlert = true;
      this.variant = "danger";
      if (pagenum == -1) {
        pagenum = 0;
      }
      survey.currentPage = pagenum;
      alert("Error");
    });
}

var surveyJSON = {};
var survey = new SurveyVue.Model(surveyJSON);
survey.cssType = "bootstrap";
survey.showNavigationButtons = false;
survey.sendResultOnPageNext = true;

export default {
  components: { Survey, Spinner },
  props: ["ExemptionApplicationId","ApplicationDetails"],

  data() {
    return {
      title: "REGISTRATION OF SECURITY GUARDS WORKING WITH  PRIVATE AGENCY",
      survey: survey,
      isLoading: false,
      variant: "success",
      alertText: "",
      showDismissibleAlert: false,
      show: true
    };
  },
  methods: {
    onSubmit() {
      //alert("The results are:" + JSON.stringify(this.survey.data));
    },
    onReset() {},

    SaveData(survey, pagenum, iscomplete) {
      let pmtObj = {};
      var userinfo = this.$store.getters.loggedUser;
      let surveyJSON = {};
      if (userinfo.RegistrationType == 11) {
        pmtObj.pmtPurpose = "Registration of Principal Employer";
      } else if (userinfo.RegistrationType == 12) {
        pmtObj.pmtPurpose =
          "Registration of Security Guards Working with Private Agency";
      } else if (userinfo.RegistrationType == 13) {
        pmtObj.pmtPurpose = "Registration of Employer Agency";
      }

      pmtObj.boardId = survey.data.Board;

      this.$store.dispatch("setPmtObject", pmtObj);
      this.$store.dispatch("setRegistrationDetails", survey.data);

      var regId = this.$store.getters.getRegId;
      var payload = {
        RegistrationID: regId,
        UserLoginID: userinfo.UserId,
        FormDetails: JSON.stringify(survey.data),
        iscomplete: iscomplete,
        LastCompletePage: pagenum,
        RegistrationType: userinfo.RegistrationType,
        BoardID: survey.data.Board,
        RegisteringAgency: "00000000-0000-0000-0000-000000000000"
      };

      let promise = apis.SaveApplicationRegistrationDetails(payload);
      promise
        .then(response => {
          //console.log('Reponse' ,response);
          if (
            response.status == 200 &&
            response.body != "Error in Registration"
          ) {
            this.$store.dispatch("setRegID", response.body);
            if (iscomplete) {
              this.$router.push("/agencypayment");
            }
          } else {
            this.survey.currentPage = pagenum;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          if (pagenum == -1) {
            pagenum = 0;
          }
          this.survey.currentPage = pagenum;
          //console.log("Reponse", err.body);
          alert("Error");
        });
    }
  },
  mounted() {
    var userinfo = this.$store.getters.loggedUser;
    let surveyJSON = {};
    if (userinfo.RegistrationType == 11) {
      this.title = "REGISTRATION OF PRINCIPAL EMPLOYER";
      surveyJSON = data.Employer;
    } else if (userinfo.RegistrationType == 12) {
      this.title = "REGISTRATION OF SECURITY GUARD WORKING WITH PRIVATE AGENCY";
      surveyJSON = data.PrivateGuard;
    } else if (userinfo.RegistrationType == 13) {
      this.title = "REGISTRATION OF EMPLOYER AGENCY";
      surveyJSON = data.Agency;
    }
    console.log(surveyJSON)
    // surveyJSON=this.ApplicationDetails;
    this.survey = new SurveyVue.Model(surveyJSON);
    this.survey.cssType = "bootstrap";
    this.survey.showNavigationButtons = false;
    this.survey.sendResultOnPageNext = true;
    var applicationId=this.ExemptionApplicationId;
    // alert(applicationId)
    
    this.survey.onPartialSend.add(function(survey) {
      sendDataToServer(survey, survey.currentPageNo, false,applicationId);
      //this.SaveData(survey, survey.currentPageNo, false);
    });
    this.survey.onComplete.add(function(survey, options) {
      survey.clear(false);
      if (survey.mode == "display") {
        survey.currentPage = 0;
        return;
      }
      sendDataToServer(survey, survey.currentPageNo, true,applicationId);
      //this.SaveData(survey, survey.currentPageNo, true);
      //router.push("/agencypayment");
    });

    this.survey.onUploadFiles.add((survey, options) => {
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = options.files[0].type;
      //console.log("Options", options);
      //var filepath = "CourtOrder_." + extn;
      var filepath = options.name + "_" + options.files[0].name;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then(response => {
          let signedUrl = response;
          var upldoptions = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": options.files[0].type
            }
          };
          return axios.put(signedUrl, options.files[0], upldoptions);
        })
        .then(res => {
          if (res.status == 200) {
            options.callback(
              "success",
              options.files.map(file => {
                return {
                  file: file,
                  //content: data[file.name]
                  content:
                    "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
                    userid +
                    "/" +
                    filepath
                };
              })
            );
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";

          this.isLoading = false;
        });
    });

    /*Edit Existing Data - Relaod the Form Data*/
    let promise = apis.ReadRegistrationDetails(
      userinfo.UserId,
      userinfo.RegistrationType
    );
     this.survey.currentPageNo = 0;
    promise
      .then(response => {
        //console.log('Reponse' ,response);
        if (
          response.status == 200 &&
          response.body != "Error in Registration"
        ) {
          this.$store.dispatch("setRegID", response.body.RegistrationID);
          this.survey.data = JSON.parse(this.ApplicationDetails);
          if (response.body.IsComplete) {
            this.survey.showCompletedPage = false;

            this.survey.currentPageNo = 0;
            // if (response.body.IsPaid) {
              //alert(response.body.IsPaid);
              //this.survey.mode = "display";
            // }
          } else {
            if (response.body.FormDetails == null) {
              this.survey.currentPageNo = 0;
            } else {
              this.survey.currentPageNo = response.body.LastCompletePage + 1;
              this.survey.currentPageNo=0;
            }
          }
        } else {
          this.survey.currentPageNo = 0;
        }
      })
      .catch(err => {
        alert("Error In Loading previous Details.");
      });
  }
};
</script>
<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}
h4 {
  font-size: 1rem !important;
}
h5 {
  font-size: 0.875rem !important;
}
.form-control {
  font-size: 0.75rem;
}
.btn sv_prev_btn {
  color: "red";
}
</style>


// WEBPACK FOOTER //
// src/components/AgencyExemption/RegisterStgApplication.vue